import { render, staticRenderFns } from "./RegistrationNumberMatchSelect.vue?vue&type=template&id=3214aa0c"
import script from "./RegistrationNumberMatchSelect.vue?vue&type=script&lang=ts"
export * from "./RegistrationNumberMatchSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports